import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { getAllBuildingsGeoJSONv1 } from '@/services/buildings.service'
import { getAllRealEstatesv1 } from '@/services/realEstates.service'
import { getAllComplexesGeoJSONv1 } from '@/services/complex.service'

export default function useFetchInitialMapData() {
  const store = useStore()
  const { t } = useI18n()
  const fetchError = ref(null)
  const initialFetchLoading = ref(true)
  const complexSource = computed(() => store.state.complexSource)
  const realEstateSource = computed(() => store.state.realEstateSource)
  const buildingSource = computed(() => store.state.buildingSource)
  const setComplexSource = (complexSource) => store.commit('SET_COMPLEX_SOURCE', complexSource)
  const setRealEstateSource = (realEstateSource) =>
    store.commit('SET_REAL_ESTATE_SOURCE', realEstateSource)
  const setBuildingSource = (buildingSource) => store.commit('SET_BUILDING_SOURCE', buildingSource)
  // const setInfoMessage = (type, message) => store.commit('setInfoMessage', { type, message })

  const fetchInitialMapData = async () => {
    let fetchCount = 0
    fetchError.value = null
    initialFetchLoading.value = true
    while (
      (!complexSource.value || !realEstateSource.value || !buildingSource.value) &&
      fetchCount < 6
    ) {
      fetchCount++
      const fetchPromises = []
      if (!complexSource.value) {
        fetchPromises.push(
          getAllComplexesGeoJSONv1(true, 9000).then((res) => {
            if (res) setComplexSource(res)
          })
        )
      }
      if (!realEstateSource.value) {
        fetchPromises.push(
          getAllRealEstatesv1(true, 9000).then((res) => {
            if (res) setRealEstateSource(res)
          })
        )
      }
      if (!buildingSource.value) {
        fetchPromises.push(
          getAllBuildingsGeoJSONv1(true, 9000).then((res) => {
            if (res) setBuildingSource(res)
          })
        )
      }
      try {
        await Promise.all(fetchPromises)
      } catch (e) {
        // setInfoMessage('error', e.message)
        console.error(e)
      }
    }
    initialFetchLoading.value = false
    if (fetchCount > 5) fetchError.value = t('message__initial-map-fetch-error')
  }
  return {
    fetchError,
    initialFetchLoading,
    fetchInitialMapData
  }
}
